import { linkToDashboard } from "features/dashboard/links";

export function linkToMorePage() {
  return `${linkToDashboard()}/more`;
}
